export default "__VITE_ASSET__Y3LS3EJD__"